import offlineStorage from "../dbService";
import ayalconfig from "../ayalconfig";
import {isEmpty} from "./service";
import store from '../store';
import webLog from "../websql/weblog";
export default class Logger {
    debug(msg, object={}){
        this.addToLogs("DEBUG", msg, object)
    }

    error(msg, object={}){
        this.addToLogs("ERROR", msg, object)
    }

    addToLogs(logStatus, msg, object){
        console.log(msg, object);
        if(!ayalconfig.logger.enableLog){
            return
        }
        try {
            let date = webLog.formatDate(new Date());
            let status = this.getStatus(logStatus);
            webLog.insert(date, status, msg, false)
        }catch (e) {
            console.log("Logging Failed.")
        }
    }

    syncLog(){
        if (navigator.onLine){
            webLog.select();
        }
    }

    getStatus(logStatus){
        const currentUser = store.getters['userInfo'];
        let status = {logStatus:logStatus};
        status.userInfo={};
        if (currentUser){
            status.userInfo.governmentId = currentUser.governmentId;
            status.userInfo.firstName = currentUser.firstName;
            status.userInfo.lastName = currentUser.lastName;
            if (currentUser.location){
                status.userInfo.long = currentUser.location.longitude;
                status.userInfo.lat = currentUser.location.latitude;
                status.userInfo.onLine = navigator.onLine;
            }
        }
        return JSON.stringify(status)
    }

    /*addToLogs(status, msg, object){
        console.log(msg, object);
        if(!ayalconfig.logger.enableLog){
            return
        }
        let date = new Date().toISOString();
        let log = {status:status, date:date, msg:msg};
        offlineStorage.getItem('logs').then((logMap)=>{
            if(!logMap || (isEmpty(logMap) && isEmpty(logMap.logs) === 0)){
                logMap = {endpoint:ayalconfig.logger.loggerEndPoint, createSyncEvent:true, logs : '[]'}
            }
            logMap.endpoint = ayalconfig.logger.loggerEndPoint;
            let logArray  = JSON.parse(logMap.logs);
            logArray.push(log);
            logMap.logs = JSON.stringify(logArray);
            offlineStorage.setItem("logs", logMap);
        })
    }
*/
}